import React, { useState } from "react";
import { Button } from "../components/Button";
import FindBusinessExternalIdModal from "../components/Visa/FindBusinessExternalIdModal";
import TransactionHistorySection from "../components/Visa/TransactionHistorySection";

const AdminVisa: React.FC = () => {
  const [isFindBusinessModalOpen, setIsFindBusinessModalOpen] = useState(false);

  return (
    <div>
      <div className="mb-8 lg:mb-12">
        <h2 className="text-black/60">Visa</h2>
      </div>

      {/* Merchant Onboarding Section */}
      <div className="bg-white rounded-lg shadow p-6">
        <h3 className="text-lg font-medium text-gray-900 mb-4">Merchant Onboarding</h3>
        <Button onClick={() => setIsFindBusinessModalOpen(true)}>
          Find Business External ID
        </Button>
      </div>

      {/* Transaction History Section */}
      <TransactionHistorySection />

      {/* Modal */}
      <FindBusinessExternalIdModal
        isOpen={isFindBusinessModalOpen}
        onClose={() => setIsFindBusinessModalOpen(false)}
      />
    </div>
  );
};

export default AdminVisa;
